
import Vue from 'vue';
import PanelLayout from '@/layouts/PanelLayout.vue';
import { ACTIONS } from '../constants/actions';
export default Vue.extend({
  name: 'BookingConfigurations',
  components: { PanelLayout },
  created(): void {
    const { dispatch } = this.$store;
    const bookingPageId = parseInt(this.$route.params.bookingPageId, 10);
    dispatch(ACTIONS.bookings.getTheBookingPage, { bookingPageId }).then(() => {
      dispatch(ACTIONS.premiums.getPremiums, { bookingPageId });
    });
  }
});
